export const hasLocationPermissions = async () => {
  const permissionStatus = await navigator?.permissions?.query({ name: 'geolocation' });

  return permissionStatus?.state !== 'denied';
};
